export const environment = {
	apiBaseUrl: 'https://qual-api.ubiq-elevage.fr',
	authenticationClientId: 'd02ab825-096a-49b0-ab01-308d71213ed6',
	authenticationIssuerUrl:
		'https://940ca853-61cd-4eb3-b46a-e30620da3430.ciamlogin.com/940ca853-61cd-4eb3-b46a-e30620da3430/v2.0',
	production: false,
};
